import { render, staticRenderFns } from "./evaluaciones.vue?vue&type=template&id=182d7209&scoped=true"
import script from "./evaluaciones.vue?vue&type=script&lang=js"
export * from "./evaluaciones.vue?vue&type=script&lang=js"
import style0 from "./evaluaciones.vue?vue&type=style&index=0&id=182d7209&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182d7209",
  null
  
)

export default component.exports